import { useEffect, useState } from "react";
import type { IAnswer, IQuestion } from "@/types/types";
import { createAnswersList } from "../inspection.util";
import EmptyAnwer from "./answer/EmptyAnswer";
import OpenAnswer from "./answer/OpenAnswer";
import { Icon } from "@/components/icons/Icon";

interface AnswerColumnProps {
  answers: IAnswer[];
  questions: IQuestion[];
  closedColumn?: boolean;
  columnName: string;
}

const AnswerColumn = ({
  columnName,
  answers = [],
  questions = [],
  closedColumn,
}: AnswerColumnProps) => {
  const [answersList, setAnswersList] = useState<any[]>([]);

  useEffect(() => {
    if (closedColumn) {
      if (questions.length && answers.length) {
        const newAnswersList = createAnswersList(questions, answers);
        setAnswersList(newAnswersList);
      }
    } else {
      const newAnswersList = createAnswersList(questions, answers);
      setAnswersList(newAnswersList);
    }
  }, [questions, answers, closedColumn]);

  return (
    <div className="bg-ib-gray-lightest-2 px-3 rounded-sm py-4 flex flex-col gap-y-4 min-w-80">
      <div className="text-ib-main font-ib-bold flex flex-row gap-x-1 items-center">
        <Icon name="lockOpen" className="size-4 text-ib-black" />
        <span className="text-ib-gray-darksest over overflow-x-hidden whitespace-nowrap text-ellipsis">
          {columnName}
        </span>
      </div>
      <>
        {answersList.map((answer, idx) => {
          if (answer.empty) {
            return (
              <EmptyAnwer
                key={`empty-${columnName}-${answer.questionId}`}
                questionId={answer.questionId}
              />
            );
          } else {
            return (
              <OpenAnswer
                key={`${columnName}-${answer.questionId}`}
                item={answer}
                idx={idx + 1}
              />
            );
          }
        })}
      </>
    </div>
  );
};

export default AnswerColumn;
